import { render, staticRenderFns } from "./BranchSelectorPPL.vue?vue&type=template&id=8e95f6e8&"
import script from "./BranchSelectorPPL.js?vue&type=script&lang=js&"
export * from "./BranchSelectorPPL.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports